<mat-card class="data-table-card">
	<mat-card-header class="data-table-card-header flex flex-row items-center justify-start gap-2">
		<mat-form-field
			appearance="fill"
			class="mat-form-field-no-hint"
		>
			<mat-label translate>utils.groupBy</mat-label>
			<mat-select
				(selectionChange)="this.applyGroup($event.value)"
				[compareWith]="groupTypeComparer"
				[value]="this.group$ | async"
			>
				<ng-container>
					<mat-option
						[value]="group"
						*ngFor="let group of allowedGroups; let i = index"
					>
						@if (i === 0) { {{ 'time.billability' | translate }} } @else { {{ group | translate }} }
					</mat-option>
				</ng-container>
			</mat-select>
		</mat-form-field>
		<div class="flex-auto"></div>
		<div class="flex flex-row items-center justify-start gap-2">
			<button
				(click)="this.openRoundingDialog()"
				[class.mat-hint]="!this.hasRounding"
				*ngIf="showRoundingButton"
				mat-icon-button
			>
				<mat-icon>access_time</mat-icon>
			</button>
		</div>
	</mat-card-header>
	<mat-card-content>
		<div class="flex flex-col justify-stretch gap-3 pb-3">
			<ng-container *ngIf="this.entries$ | async as entries">
				<ng-container *ngIf="entries.length > 0; else noEntries">
					<mat-accordion
						[displayMode]="'flat'"
						[hideToggle]="true"
						[multi]="false"
						#panelList
						class="mat-accordion-cards mat-elevation-z0"
					>
						<ng-container *ngFor="let item of entries; let lastHeader = last; trackBy: trackItem">
							<ng-container *ngIf="item.value.length > 0">
								<mat-expansion-panel
									[class.brd-b]="!lastHeader"
									[hideToggle]="true"
									#panel
									class="mat-elevation-z0 mat-expansion-card"
								>
									<mat-expansion-panel-header
										collapsedHeight="56px"
										expandedHeight="56px"
									>
										<div
											class="flex flex-row items-center justify-start gap-[10px]"
											fxFill
										>
											<div
												[style.backgroundColor]="item.group === this.groupTypes.Project ? item.data.project.color  : this.getEntityColor(item.key)"
												*ngIf="showColors"
												class="data-color-column"
											></div>
											<div
												[style.width.px]="40"
												*ngIf="!panel.expanded"
												class="badge badge-stroked"
											>
												{{ item.value.length > 9 ? '9+' : item.value.length }}
											</div>
											<div class="data-title-column flex flex-col">
												<ng-container *ngIf="item.group === this.groupTypes.Client">
													<span class="flex flex-row items-center">
														<span
															[matTooltip]="'client.color' | translate"
															[style.backgroundColor]="clientDisplayColor(item.data.client)"
															class="project-color-dot flex-shrink-0 self-center mr-1"
														></span>
														<span class="mat-truncate">{{
															item.data.client | defaultEntityTranslate: 'client' : 'client.none'
														}}</span>
													</span>
												</ng-container>

												<ng-container *ngIf="item.group === this.groupTypes.Task">
													<span class="mat-truncate">{{
														item.data.task?.name || ('task.none' | translate)
													}}</span>
												</ng-container>
												<ng-container *ngIf="item.group === this.groupTypes.Project">
													<span
														[innerHTML]="item.data.project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
														class="mat-truncate"
													></span>
												</ng-container>
												<ng-container *ngIf="item.group === this.groupTypes.User">
													<span class="mat-truncate">{{ item.data.user.name }}</span>
												</ng-container>
												<ng-container *ngIf="item.group === this.groupTypes.Billable">
													<span class="mat-truncate">{{
														(item.data.billable ? 'Billable' : 'NonBillable') | translate
													}}</span>
												</ng-container>
												<ng-container
													*ngIf="this.hasShowParentFlag(this.groupTypes.Task) && [this.groupTypes.Task].includes(item.group)"
												>
													<div class="flex flex-row items-center justify-start gap-1">
														<span
															[matTooltip]="'project.color' | translate"
															[style.backgroundColor]="getProjectColor(item.data.project?.id)"
															*ngIf="item.data.project?.id"
															class="project-color-dot flex-shrink-0 self-center mr-1"
														></span>
														<small
															[innerHTML]="item.data.project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
															[matTooltip]="item.data.client | defaultEntityTranslate: 'client' : 'client.none'"
															class="mat-hint text-wrap-line data-short-name text-ellipsis"
														></small>
													</div>
												</ng-container>

												<ng-container
													*ngIf="this.hasShowParentFlag(this.groupTypes.Project) && [this.groupTypes.Project].includes(item.group)"
												>
													<div class="flex flex-row items-center justify-start gap-1">
														<small class="mat-hint mat-truncate">{{
															item.data.client | defaultEntityTranslate: 'client' : 'client.none'
														}}</small>
													</div>
												</ng-container>
											</div>
											<div class="!ml-auto">{{ item.sum() }}</div>
											@if(item.group == this.groupTypes.Project ) {
											<div>
												<app-estimation-statistics-graph
													[completed]="item.estStat.completed"
													[estimation]="item.estStat.estimation || 0"
													[inReports]="true"
													[recorded]="getRecordedTime(item.estStat)"
													class="mr-1"
												></app-estimation-statistics-graph>
											</div>
											} @if(item.group == this.groupTypes.Task && item.estStat.estimation > 0) {
											<div>
												<app-estimation-statistics-graph
													[completed]="item.estStat.completed"
													[estimation]="item.estStat.estimation"
													[inReports]="true"
													[recorded]="getRecordedTime(item.estStat)"
													class="mr-1"
												></app-estimation-statistics-graph>
											</div>
											} @else {
											<div class="mr-1 w-[28px]"></div>
											}
										</div>
									</mat-expansion-panel-header>
									<ng-template matExpansionPanelContent>
										<cdk-virtual-scroll-viewport
											[itemSize]="48"
											[style.height.px]="item.value.length > 10 ? 600 : (item.value.length * 48).clampThis(100)"
											class="data-row-container flex flex-col"
										>
											<ng-container
												*cdkVirtualFor="let entry of item.value; let last = last; let index = index; trackBy: trackItemEntry"
											>
												<ng-container
													*ngTemplateOutlet="
                            timesItem;
                            context: {
                              item: entry,
                              last: last,
                              index: index,
                              group: item.group,
                            }
                          "
												></ng-container>
											</ng-container>
										</cdk-virtual-scroll-viewport>
									</ng-template>
								</mat-expansion-panel>
							</ng-container>
						</ng-container>
					</mat-accordion>
				</ng-container>
			</ng-container>
		</div>
	</mat-card-content>
</mat-card>
<ng-template
	#timesItem
	let-group="group"
	let-index="index"
	let-item="item"
	let-last="last"
>
	<div
		(click)="onEntryClick(group, item)"
		[class.cursor-pointer]="item.currentUserCanEdit && (this.nameClickOpensEdit || namePress.observed)"
		class="data-row flex flex-row items-center justify-start gap-2"
	>
		<div class="flex flex-col truncate">
			<div class="flex items-center space-x-1 truncate">
				<ng-container *ngIf="group === 'task'; else nonTaskName">
					<span class="flex-shrink-0 truncate">{{ item.name || ('time.none' | translate) }}</span>
				</ng-container>
				<ng-template #nonTaskName>
					<span class="flex-shrink-0 truncate">{{ item.name || ('time.none' | translate) }}</span>
					<div class="mat-bg-30 h-1 w-1 flex-shrink-0 rounded-full"></div>
					<span class="mat-hint truncate">{{ item.task?.name || ('task.none' | translate) }}</span>
				</ng-template>
			</div>
			<ng-container
				*ngIf="this.hasShowParentFlag(this.groupTypes.User) && [this.groupTypes.User].includes(group)"
			>
				<div class="flex flex-row items-center justify-start gap-1 text-sm">
					<!-- Client Dot -->
					<ng-container *ngIf="item.client">
						<div
							[style.background]="clientDisplayColor(item.client)"
							class="project-color-dot flex-shrink-0 self-center mr-1"
						></div>
					</ng-container>
					<span class="mat-hint mat-truncate">{{
						item.client | defaultEntityTranslate: 'client' : 'client.none'
					}}</span>
					<span>/</span>
					<!-- Project Dot -->
					<ng-container *ngIf="item.project">
						<div
							[style.background]="getProjectColor(item.project.id)"
							class="project-color-dot flex-shrink-0 self-center mr-1"
						></div>
					</ng-container>
					<span
						[innerHTML]="item.project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
						class="mat-hint mat-truncate"
					></span>
				</div>
			</ng-container>
			<ng-container
				*ngIf="this.hasShowParentFlag(this.groupTypes.Client) && [this.groupTypes.Client].includes(group)"
			>
				<div class="flex flex-row items-center justify-start gap-1 text-sm">
					<!-- Project Dot -->
					<ng-container *ngIf="item.project">
						<div
							[style.background]="getProjectColor(item.project.id)"
							class="project-color-dot flex-shrink-0 self-center mr-1"
						></div>
					</ng-container>
					<span
						[innerHTML]="item.project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
						class="mat-hint mat-truncate"
					></span>
					<ng-container *ngIf="item.user?.name as username">
						<div class="mat-bg-80 rounded-circle h-1 w-1"></div>
						<span class="mat-hint mat-truncate">{{ username }}</span>
					</ng-container>
				</div>
			</ng-container>
			<ng-container
				*ngIf="[this.groupTypes.Project, this.groupTypes.Task].includes(group) && item.user?.name as username"
			>
				<div class="flex flex-row items-center justify-start gap-1 text-sm">
					<span class="mat-hint mat-truncate">{{ username }}</span>
				</div>
			</ng-container>
		</div>
		<div class="flex-auto"></div>
		<div class="flex flex-row items-center justify-start gap-2 wflex-[0_0_auto]">
			<ng-container *ngIf="item.billable && this.currencyCode">
				<mat-icon
					color="accent"
					inline
				>
					{{ this.currencyCode }}
				</mat-icon>
				<mat-divider
					style="width: 1px; height: 8px"
					vertical
				></mat-divider>
			</ng-container>
			<span>{{ item.timeDiff | parseMsAsDuration: false }}</span>
			<mat-divider
				style="width: 1px; height: 10px"
				vertical
			></mat-divider>
			<div class="data-time-column flex flex-col gap-1 wflex-[0_0_auto]">
				<div
					aria-multiselectable
					class="line-height-base flex flex-row items-center justify-start gap-1"
				>
					<small>{{ item['viewStart'] ?? item.start | dfnsParseIso | formatDate: 'time' }}</small>
					<small>-</small>
					@if(!item.end) {
					<small class="text-red-500">Now</small>
					} @else {
					<small>{{ item['viewEnd'] ?? item.end | dfnsParseIso | formatDate: 'time' }}</small>
					}
				</div>
				<small class="line-height-base">{{
					item['viewStart'] ?? item.start | dfnsParseIso | formatDate: 'P'
				}}</small>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #noEntries> <div class="mat-hint py-10 text-center">{{ 'errors.empty' | translate }}</div> </ng-template>
<mat-menu #headerSettings="matMenu">
	<ng-template matMenuContent>
		<h4 class="mat-typography mat-header-cell mx-2 mb-1 mt-1">Settings</h4>
		<button
			(click)="this.openRoundingDialog()"
			[disabled]="!this.showRoundingButton"
			[matBadge]="' '"
			[matBadgeHidden]="!this.hasRounding"
			mat-menu-item
		>
			<mat-icon>history</mat-icon>
			{{ 'Rounding' | translate }}
		</button>
	</ng-template>
</mat-menu>
